import axios from 'axios'
import { Answer } from '@verifiedit/form-generator'
import { SupplementalParent } from '@/storage/supplementalForms'

export async function submitSupplementalForm(
  supplementalFormId: number,
  formData: { [key: string]: Answer },
  siteId: number,
  siteUuid: string,
  checkedInAt: string,
  submittedAt: string,
  parent: SupplementalParent,
  meta?: Record<string, unknown>,
  contractorCompanyName?: string,
) {
  return await axios.post('api/supplemental-forms', {
    checkedInAt,
    contractorCompanyName,
    formData,
    meta,
    parent,
    siteId,
    siteUuid,
    submittedAt,
    supplementalFormId,
  })
}
